import PropTypes from "prop-types";

import { defineMessages, injectIntl } from "react-intl";

import { Helmet } from "react-helmet";

import ImmutablePropTypes from "react-immutable-proptypes";
import ImmutablePureComponent from "react-immutable-pure-component";
import { connect } from "react-redux";

import { getStatusList } from "flavours/glitch/selectors";

import { fetchPinnedStatuses } from "../../actions/pin_statuses";
import ColumnHeader from "flavours/glitch/components/column_header";
import PageFrame from "flavours/glitch/features/ui/components/page_frame";
import StatusList from "../../components/status_list";

const messages = defineMessages({
  heading: { id: "column.pins", defaultMessage: "Pinned post" },
});

const mapStateToProps = state => ({
  statusIds: getStatusList(state, "pins"),
  hasMore: !!state.getIn(["status_lists", "pins", "next"]),
});

class PinnedStatuses extends ImmutablePureComponent {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    statusIds: ImmutablePropTypes.list.isRequired,
    intl: PropTypes.object.isRequired,
    hasMore: PropTypes.bool.isRequired,
    multiColumn: PropTypes.bool,
    embedded: PropTypes.bool,
  };

  UNSAFE_componentWillMount () {
    this.props.dispatch(fetchPinnedStatuses());
  }

  handleHeaderClick = () => {
    this.column.scrollTop();
  };

  setRef = c => {
    this.column = c;
  };

  render () {
    const { intl, statusIds, hasMore, multiColumn, embedded } = this.props;
    const title = intl.formatMessage(messages.heading);

    return (
      <PageFrame embedded={embedded} bindToDocument={!multiColumn} ref={this.setRef} label={title}>
        <ColumnHeader icon='push-pin' title={title} multiColumn={multiColumn} showBackButton />
        <StatusList
          statusIds={statusIds}
          scrollKey='pinned_statuses'
          hasMore={hasMore}
          bindToDocument={!multiColumn && !embedded}
        />
        <Helmet>
          <meta name='robots' content='noindex' />
        </Helmet>
      </PageFrame>
    );
  }

}

export default connect(mapStateToProps)(injectIntl(PinnedStatuses));
